import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  InsightsIcon,

  Insights,
  TrackReceivables,
  KnowYourCustomer,
  AIGeneratedReport,
  MonitorShipment,
  AutoHoldShipment,
} from '../../assets';

const AnalyticsPage = () => {
  const productData = {
    productName: 'Analytics',
    tagline: 'Actionable Insights for Faster Decisions',
    metaDescription: 'Freight analytics dashboards for logistics: sales performance, receivables aging, customer risk scoring, and AI-generated reports for smarter business decisions.',
    description: 'Drive decisions with data. Access comprehensive dashboards for Sales performance, Operational health, Billing trends, and Business Health Pulse.',
    icon: InsightsIcon,
    features: [
      {
        title: 'Make Faster Decisions with Insights',
        description: 'Access real-time dashboards with key metrics for sales, operations, and finance.',
        image: Insights,
      },
      {
        title: 'Track Receivables and Collections',
        description: 'Monitor aging receivables, collection trends, and DSO across customers.',
        image: TrackReceivables,
      },
      {
        title: 'Identify High-Risk Customers',
        description: 'Know your customers with risk scores, payment history, and credit analysis.',
        image: KnowYourCustomer,
      },
      {
        title: 'Gen AI-Generated Reports',
        description: 'Get AI-powered insights and recommendations from your logistics data.',
        image: AIGeneratedReport,
      },
      {
        title: 'Monitor Shipment Progress',
        description: 'Track shipment milestones, identify bottlenecks, and resolve exceptions faster.',
        image: MonitorShipment,
      },
      {
        title: 'Auto-Hold for High-Risk Transactions',
        description: 'Automatically flag low-margin or credit-heavy customers for review.',
        image: AutoHoldShipment,
      },
    ],

  };

  return <ProductPageTemplate {...productData} />;
};

export default AnalyticsPage;
